import React, { useContext, useEffect, useState } from 'react'
import { MenuItem, Button, FormControl, FormLabel, RadioGroup } from '@mui/material'
import { validate } from './Services/validate'
import { getNameWithCode, RequestData } from './Services/utils'
import {
  renderInputField,
  renderSelectField,
  renderCheckBox,
  renderRadioButton,
  renderTextField
} from './Services/renderer'
import jsonCountries from './Resources/countries.json'
import jsonStates from './Resources/US-states.json'
import jsonJobFunction from './Resources/jobFunction.json'
import jsonInterestedInMG from './Resources/interestedInMatrixGold.json'
import jsonInterestedInCS from './Resources/interestedInCounterSketch.json'
import { useNavigate } from 'react-router-dom'
import { ConfigContext } from './App'
import { Form, Field } from 'react-final-form'
import { signOut } from 'aws-amplify/auth'
import ReCAPTCHA from 'react-google-recaptcha'

const RequestDemoForm = ({ buttonColor, product, showAlert }) => {
  const [isStullerUser, setIsStullerUser] = useState(false)
  const [visibleSelectorStates, setVisibleSelectorStates] = useState(false)
  const [reCaptchaToken, setReCaptchaToken] = useState('')
  const interestedInAnswers = product.includes('countersketch') ? jsonInterestedInCS : jsonInterestedInMG

  const context = useContext(ConfigContext)
  const navigate = useNavigate()
  const groups = [
    'Search engine (Google, Yahoo, etc...)',
    'Social media',
    'Blog or digital publication',
    'Recommended by friend or colleague',
    'Email',
    'Gemvision or Stuller territory manager',
    'Other'
  ]
  const socialMedia = ['Facebook', 'YouTube', 'LinkedIn', 'Instagram', 'Twitter']
  const contactOptions = ['Email', 'Phone']

  const onSubmitForm = async (values) => {
    for (const key in values) {
      if (typeof values[key] === 'string') {
        values[key] = values[key].trim()
      }
    }

    const dataForm = {
      userName: values.name,
      lastName: values.lastName,
      email: values.email,
      phone: values.phone,
      country: getNameWithCode(values.country, jsonCountries),
      organization: values.organization,
      jobFunction: values.jobFunction.charAt(0).toUpperCase() + values.jobFunction.substring(1),
      interested: values.interested.charAt(0).toUpperCase() + values.interested.substring(1),
      contactOption: values.contactOptions,
      stullerAccount: values.stullerAccount,
      questions: values.questions,
      aboutUs: [],
      product
    }
    if (values.questions === 'Social media') {
      socialMedia.map((type) => {
        if (values[type] && values[type] === true) {
          dataForm.aboutUs.push(type)
        }
      })
    } else if (values.questions === 'Other' && values['textArea-other']) {
      dataForm.aboutUs.push(values['textArea-other'])
    }
    if (values.jobFunction === 'other') {
      dataForm.jobFunctionDetails = values['textArea-jobFunction']
    }
    if (values.country.toLowerCase() === 'us') {
      dataForm.stateName = getNameWithCode(values.state, jsonStates)
    }
    if (values.interested === 'other') {
      dataForm.interested = values['textArea-interested']
    }
    try {
      await RequestData(dataForm)
      navigate('/' + product + '/confirmation')
    } catch (error) {
      if (typeof error === 'string') {
        showAlert(error)
      } else {
        showAlert('Error, try again later or contact our sales team if the error persist.')
      }
    }
  }

  const onChangeCountry = (data) => {
    if (data === 'us') {
      setVisibleSelectorStates(true)
    } else {
      setVisibleSelectorStates(false)
    }
  }

  const onChangeReCaptcha = (token) => {
    setReCaptchaToken(token)
  }

  const selectState = () => {
    return (
      <Field name='state' component={renderSelectField} label={'State *'}>
        {jsonStates.map((data, index) => (
          <MenuItem value={data.value.toLowerCase()} key={data.value + index}>
            {data.text}
          </MenuItem>
        ))}
      </Field>
    )
  }

  useEffect(() => {
    if (context.params.stullerAccount) {
      setIsStullerUser(true)
    } else {
      setIsStullerUser(false)
    }
    if (context.params.country === 'US' || context.params.country === 'us') {
      setVisibleSelectorStates(true)
    }
  }, [context.params.stullerAccount])

  const FormUserLogged = () => {
    return (
      <>
        <p>
          You are successfully logged in as
          <b> {context.params.fullName}. </b>
          <span
            style={{ cursor: 'pointer', textDecoration: 'underline' }}
            onClick={() => {
              signOut()
              context.resetContext()
            }}
          >
            (Log out)
          </span>
        </p>
      </>
    )
  }

  const FormUserNotLogged = () => {
    return (
      <>
        <div>
          <p>
            Are you a current Stuller customer? &nbsp;
            <a
              href={
                !document.location.hostname.includes('localhost')
                  ? `https://gemvision.com/login/?getBack=${document.baseURI}`
                  : `http://localhost:3000/login/?getBack=${document.baseURI}`
              }
              title='Gemvision Login'
            >
              Log in
            </a>
          </p>
        </div>
        <div>
          <Field name='name' component={renderInputField} label={'First Name *'} />
        </div>
        <div>
          <Field name='lastName' component={renderInputField} label={'Last Name *'} />
        </div>
        <div>
          <Field name='email' component={renderInputField} label={'Email *'} />
        </div>
        <div>
          <Field name='phone' component={renderInputField} label={'Phone number *'} />
        </div>
        <div>
          <Field
            name='country'
            component={renderSelectField}
            label={'Country *'}
            options={jsonCountries}
            onChangeCountry={onChangeCountry}
          >
            {jsonCountries.map((data, index) => (
              <MenuItem value={data.value} key={data.value + index}>
                {data.text}
              </MenuItem>
            ))}
          </Field>
        </div>
        {visibleSelectorStates && <div>{selectState()}</div>}
        <div>
          <Field name='organization' component={renderInputField} label={'Organization *'} />
        </div>
      </>
    )
  }

  const optionsQuestion = () => {
    return socialMedia.map((type, index) => (
      <Field name={type} label={type} component={renderCheckBox} key={index} type='checkbox' />
    ))
  }

  const optionsOther = (field, values, touched) => {
    return (
      <Field
        name={`textArea-${field}`}
        component={renderTextField}
        field={field}
        label='Please, specify *'
        error={
          (touched[`textArea-${field}`] && !values[`textArea-${field}`]) ||
          values[`textArea-${field}`]?.toString().trim() === ''
        }
      />
    )
  }

  const requiredLabel = () => {
    return (
      <FormControl error style={{ marginBottom: '-1rem' }}>
        <FormLabel component='legend'>Required *</FormLabel>
      </FormControl>
    )
  }

  return (
    <Form
      enableReinitialize={true}
      keepDirtyOnReinitialize={true}
      initialValues={context.params}
      validate={validate}
      onSubmit={onSubmitForm}
      render={({ handleSubmit, submitting, values, touched, errors }) => {
        values.product = product
        return (
          <form onSubmit={handleSubmit}>
            {isStullerUser ? <FormUserLogged /> : <FormUserNotLogged values={values} touched={touched} />}
            <div style={{ marginTop: '.5rem' }}>
              <div>
                <Field
                  name='jobFunction'
                  component={renderSelectField}
                  label={'What is your primary job function? *'}
                  options={jsonJobFunction}
                >
                  {jsonJobFunction.map((data, index) => (
                    <MenuItem value={data.value} key={data.value + index}>
                      {data.text}
                    </MenuItem>
                  ))}
                </Field>
                {values.jobFunction === 'other' && <div>{optionsOther('jobFunction', values, touched)}</div>}
              </div>
              <div>
                <Field
                  name='interested'
                  component={renderSelectField}
                  label={`Why are you interested in ${
                    product.includes('countersketch') ? 'CounterSketch' : 'MatrixGold'
                  }? *`}
                  options={interestedInAnswers}
                >
                  {interestedInAnswers.map((data, index) => (
                    <MenuItem value={data.text.toLowerCase()} key={data.text + index}>
                      {data.text}
                    </MenuItem>
                  ))}
                </Field>
                {values.interested === 'other' && <div>{optionsOther('interested', values, touched)}</div>}
              </div>
              <FormControl error={!!(touched.contactOptions && !!errors.contactOptions)} style={{ width: '100%' }}>
                <div style={{ marginTop: '1.5rem' }}>
                  <FormLabel>Would you rather be contacted by phone or email? *</FormLabel>
                  <RadioGroup>
                    {contactOptions.map((item) => {
                      return (
                        <Field
                          name='contactOptions'
                          component={renderRadioButton}
                          label={item}
                          key={item}
                          value={item}
                          type='radio'
                        />
                      )
                    })}
                  </RadioGroup>
                  {touched.contactOptions && !!errors.contactOptions && requiredLabel()}
                </div>
              </FormControl>
              <FormControl error={!!(touched.questions && !!errors.questions)} style={{ width: '100%' }}>
                <div>
                  <FormLabel>
                    How did you hear about {product.includes('countersketch') ? 'CounterSketch' : 'MatrixGold'}? *
                  </FormLabel>
                  <RadioGroup>
                    {groups.map((item) => {
                      return (
                        <Field
                          name='questions'
                          component={renderRadioButton}
                          label={item}
                          key={item}
                          value={item}
                          type='radio'
                        />
                      )
                    })}
                  </RadioGroup>
                  {touched.questions && !!errors.questions && requiredLabel()}
                </div>
              </FormControl>
            </div>
            {values.questions === 'Social media' && (
              <FormControl error={!!errors.socialMedia}>
                <div>{optionsQuestion()}</div>
                {socialMedia.find((socialMedia) => touched[socialMedia]) && !!errors.socialMedia && requiredLabel()}
              </FormControl>
            )}
            {values.questions === 'Other' && <div>{optionsOther('other', values, touched)}</div>}
            <div>
              <Field
                name='aceptTerms'
                type='checkbox'
                label={
                  <p>
                    I have read and accepted the{' '}
                    <a href='https://gemvision.com/privacy' target='_blank' rel='noreferrer' title='privacy policy'>
                      privacy policy *
                    </a>
                  </p>
                }
                component={renderCheckBox}
              />
            </div>
            <div
              data-testid='recaptcha'
              style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '1.5rem' }}
            >
              <ReCAPTCHA
                sitekey={context.params.recaptchaApiKey || 'undefined'}
                onChange={onChangeReCaptcha}
                theme={'dark'}
              />
            </div>
            <div>
              <Button
                type='submit'
                color='primary'
                size='large'
                fullWidth
                style={{ backgroundColor: buttonColor }}
                disabled={submitting || !reCaptchaToken}
              >
                Submit
              </Button>
            </div>
          </form>
        )
      }}
    />
  )
}

export default RequestDemoForm
